<!--STATUS TAG-->
@switch (eventState()) {
	@case (EventState.Active) {
		<div class="statusTag {{ SimStatusPalette.busy }} " [class.border]="border()">
			<mat-icon fontIcon="fa-play-circle" fontSet="fas" inline />
			<span>
				{{ T.SHARED_EVENT_STATE_ACTIVE | translate }}
			</span>
		</div>
	}
	@case (EventState.Archived) {
		<div class="statusTag {{ SimStatusPalette.inactive }} " [class.border]="border()">
			<mat-icon fontIcon="fa-archive" fontSet="fas" inline />
			<span>
				{{ T.SHARED_EVENT_STATE_ARCHIVED | translate }}
			</span>
		</div>
	}
	@case (EventState.Draft) {
		<div class="statusTag {{ SimStatusPalette.inactive }}" [class.border]="border()">
			<mat-icon fontIcon="fa-file" fontSet="fas" inline />
			<span>
				{{ T.SHARED_EVENT_STATE_DRAFT | translate }}
			</span>
		</div>
	}
	@case (EventState.Inactive) {
		<div class="statusTag {{ SimStatusPalette.success }} " [class.border]="border()">
			<mat-icon fontIcon="fa-check-double" fontSet="fas" inline />
			<span>
				{{ T.SHARED_EVENT_STATE_INACTIVE | translate }}
			</span>
		</div>
	}
	@case (EventState.Planned) {
		<div class="statusTag {{ SimStatusPalette.warn }} " [class.border]="border()">
			<mat-icon fontIcon="fa-calendar-day" fontSet="fas" inline />
			<span>
				{{ T.SHARED_EVENT_STATE_PLANNED | translate }}
			</span>
		</div>
	}
}
